import { render, staticRenderFns } from "./ModalTopContentShare.vue?vue&type=template&id=47ad75ae"
import script from "./ModalTopContentShare.vue?vue&type=script&lang=js"
export * from "./ModalTopContentShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports